module.exports = __webpack_public_path__ + "../assets/lead-created-screen_mobile.png";